<div class="modal-overlay" (mousedown)="closed.emit()">
  <div
    class="modal-card sk-addm"
    role="dialog"
    aria-modal="true"
    aria-labelledby="sk-addm-title"
    (mousedown)="$event.stopPropagation()"
    (keydown.escape)="closed.emit()"
    cdkTrapFocus
    [cdkTrapFocusAutoCapture]="true"
  >
    <div class="modal-head">
      <div>
        <div class="modal-sub">{{ 'skillManagement.add.sub' | translate }}</div>
        <div class="modal-title" id="sk-addm-title">
          {{ 'skillManagement.add.title' | translate }}
        </div>
      </div>
      <button
        type="button"
        class="modal-x"
        (click)="closed.emit()"
        [attr.aria-label]="'general.close' | translate"
      >
        <app-skill-icon name="close" [size]="22" />
      </button>
    </div>

    <div class="modal-body">
      <div class="sk-lang-pair sk-addm-pair">
        <label class="bf-field">
          <span class="bf-label"
            ><span class="sk-lang">DE</span
            >{{ 'skillManagement.detail.nameDe' | translate }}</span
          >
          <input
            class="bf-input"
            lang="de"
            cdkFocusInitial
            [class.bf-input--invalid]="!!duplicateDeCategory"
            [attr.aria-invalid]="!!duplicateDeCategory"
            [maxlength]="limits.SHORT_LABEL"
            [placeholder]="'skillManagement.add.placeholderDe' | translate"
            [(ngModel)]="faehigkeit"
          />
          @if (duplicateDeCategory; as category) {
            <span class="sk-hint sk-hint--warn">{{
              'skillManagement.add.duplicate'
                | translate: { category: category }
            }}</span>
          }
        </label>
        <label class="bf-field">
          <span class="bf-label"
            ><span class="sk-lang">EN</span
            >{{ 'skillManagement.detail.nameEn' | translate }}</span
          >
          <input
            class="bf-input"
            lang="en"
            [class.bf-input--invalid]="!!duplicateEnCategory"
            [attr.aria-invalid]="!!duplicateEnCategory"
            [maxlength]="limits.SHORT_LABEL"
            [placeholder]="
              'skillManagement.detail.nameEnPlaceholder' | translate
            "
            [(ngModel)]="faehigkeitEn"
          />
          @if (duplicateEnCategory; as category) {
            <span class="sk-hint sk-hint--warn">{{
              'skillManagement.add.duplicate'
                | translate: { category: category }
            }}</span>
          }
        </label>
        <div class="bf-field">
          <span class="bf-label" aria-hidden="true">&nbsp;</span>
          <button
            type="button"
            class="sk-copy"
            (click)="copyGermanToEnglish()"
            [title]="'skillManagement.detail.copyDeToEnTitle' | translate"
          >
            {{ 'skillManagement.detail.copyDeToEn' | translate }}
          </button>
        </div>
      </div>

      @if (hasControlCharacters) {
        <p class="sk-hint sk-hint--warn sk-addm__error" role="alert">
          {{ 'skillManagement.add.controlCharacters' | translate }}
        </p>
      }

      @if (otherCategories.length > 0 && !duplicateDeCategory) {
        <div class="sk-add-info">
          <app-skill-icon name="away" [size]="16" />
          <span
            >{{
              'skillManagement.add.otherCategory'
                | translate: { name: faehigkeit.trim() }
            }}
            <b>{{ otherCategories.join(', ') }}</b
            >{{ 'skillManagement.add.otherCategoryHint' | translate }}</span
          >
        </div>
      }

      <div class="sk-addm-grid">
        <div class="bf-field">
          <span class="bf-label">{{
            'skillManagement.add.category' | translate
          }}</span>
          <app-ci-select
            class="sk-category"
            variant="outline"
            [(ngModel)]="category"
            [items]="categoryOptions"
            [displayWith]="categoryName"
            [isDisabled]="isCategoryDisabled"
            [ariaLabel]="'skillManagement.detail.category' | translate"
            [required]="true"
            [placeholder]="'skillCategorySelect.placeholder' | translate"
            [searchPlaceholder]="'skillCategorySelect.search' | translate"
            [searchClearLabel]="'ciSelect.clearSearch' | translate"
            [emptyLabel]="'skillCategorySelect.empty' | translate"
            [hitTemplate]="'ciSelect.hits' | translate"
          ></app-ci-select>
          @if (hasCategoriesWithoutEnglish) {
            <span class="sk-hint sk-addm__category-hint">{{
              'skillManagement.add.categoryWithoutEnglish' | translate
            }}</span>
          }
        </div>
        <label class="bf-field">
          <span class="bf-label">{{
            'skillManagement.detail.wiki' | translate
          }}</span>
          <input
            class="bf-input"
            [maxlength]="limits.URL"
            [placeholder]="'skillManagement.add.placeholderWiki' | translate"
            [(ngModel)]="wikipage"
          />
        </label>
      </div>

      <div class="sk-addm__flags">
        <span class="bf-label">{{
          'skillManagement.add.belongsTo' | translate
        }}</span>
        <div class="sk-addm__chips">
          @for (option of flagOptions; track option.flag) {
            <button
              type="button"
              class="fchip"
              [class.fchip--on]="flags[option.flag]"
              [attr.aria-pressed]="flags[option.flag]"
              (click)="toggleFlag(option.flag)"
            >
              {{ option.label | translate }}
            </button>
          }
        </div>
      </div>
    </div>

    <div class="modal-foot">
      <span class="modal-count">
        @if (!complete) {
          {{ 'skillManagement.add.incomplete' | translate }}
        } @else if (canCreate) {
          {{ 'skillManagement.add.ready' | translate }}
        }
      </span>
      <div class="modal-actions">
        <button type="button" class="btn-text" (click)="closed.emit()">
          {{ 'general.cancel' | translate }}
        </button>
        <button
          type="button"
          class="btn-primary"
          [disabled]="!canCreate"
          (click)="create()"
        >
          {{ 'skillManagement.add.submit' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
